module.exports = __webpack_public_path__ + "img/home-bottom.ee287320.png";